import { IHistoryData } from "components/shared/modals/FeeHistoryModal/FeeHistoryModal"
import { IGetLaundryCancelCommissionData, ILaundryBranch, ILaundryCancelCommission, ILaundryCommission } from "types/laundry"

interface IGenerateFromScheduleIntervalArgs {
  T: any
  scheduleInterval: number
  inputData: ILaundryBranch[]
  selectedBranches: number[]
}

interface IGenerateFromCommissionArgs {
  T: any
  commission: ILaundryCommission | null
  inputData: ILaundryBranch[]
  selectedBranches: number[]
}

interface IGenerateFromCancelCommissionsArgs {
  T: any
  commissionData: ILaundryCancelCommission[]
  inputData: IGetLaundryCancelCommissionData[]
  selectedBranches: number[]
}

export const generateFeeHistoryFromScheduleInterval = ({
  T,
  scheduleInterval,
  inputData,
  selectedBranches
}: IGenerateFromScheduleIntervalArgs): IHistoryData[] => {
  const outputData: IHistoryData[] = inputData.reduce((acc: IHistoryData[], item: ILaundryBranch)=>{

    if(selectedBranches.includes(item.id)) {
      acc.push({
        id: item.id,
        logoUrl: item.logoUrl,
        address: item.address,
        currentLabel: T("მიმდინარე ინტერვალი"),
        currentValues: [item.scheduleInterval!],
        newLabel: T("ახალი ინტერვალი"),
        newValues: [scheduleInterval]
      })
    }

    return acc
  },[])

  return outputData
}

export const generateFeeHistoryFromBookingFee = ({
  T,
  commission,
  inputData,
  selectedBranches
}: IGenerateFromCommissionArgs): IHistoryData[] => {
  const outputData: IHistoryData[] = inputData.reduce((acc: IHistoryData[], item: ILaundryBranch)=>{

    if(selectedBranches.includes(item.id)) {
      acc.push({
        id: item.id,
        logoUrl: item.logoUrl,
        address: item.address,
        currentLabel: T("მიმდინარე საკომისიო"),
        currentValues: [item.commission!],
        newLabel: T("ახალი საკომისიო"),
        newValues: [commission?.commission || 0],
        currentCommissionType: item?.commissionType,
        newCommissionType: commission?.commissionType 
      })
    }

    return acc
  },[])

  return outputData
}

export const generateFeeHistoryFromCancellationFees = ({
  T,
  commissionData,
  inputData,
  selectedBranches
}: IGenerateFromCancelCommissionsArgs): IHistoryData[] => {
  const outputData: IHistoryData[] = inputData.reduce((acc: IHistoryData[], item: IGetLaundryCancelCommissionData)=>{
    if(selectedBranches.includes(item.carWashId)) {
      const currentCommissionType = item.commissionData[0].commissionType
      const currentValues = item.commissionData.map(( commissionData ) => commissionData.commission)
      const newValues = commissionData.map(( commissionData ) => commissionData.commission) as number[]
      const newCommissionType = commissionData[0].commissionType

      acc.push({
        id: item.carWashId,
        logoUrl: item.carWashLogoUrl,
        address: item.carWashAddress,
        currentLabel: T("მიმდინარე საკომისიო"),
        currentValues,
        newLabel: T("ახალი საკომისიო"),
        newValues,
        currentCommissionType,
        newCommissionType
      })
    }

    return acc
  },[])
  
  return outputData
}